<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="userForm">
        <div class="mt-5">
          <div class="col-md-8 mb-3">
            <label for="firstName">First Name</label>
            <input type="text" class="form-control" formControlName="firstName" id="firstName"
                   placeholder="First Name">
          </div>
          <div class="col-md-8 mb-3">
            <label for="lastName">Last Name</label>
            <input type="text" class="form-control" formControlName="lastName" id="lastName" placeholder="Last Name">
          </div>
          <div class="col-md-8 mb-3">
            <label for="lastName">Phone</label>
            <input type="text" class="form-control" formControlName="phone" id="phone" placeholder="Phone">
          </div>

          <div class="col-md-8 mb-3">
            <label for="email">Email</label>
            <input type="text" class="form-control" formControlName="email" id="email" placeholder="Email">
          </div>

          <div class="col-md-8 mb-3">
            <label for="roles">Roles</label>
            <select class="form-control" id="roles" formControlName="roles" multiple>
              <option *ngFor="let role of roleOptions" [value]="role" [selected]="user && user.roles.includes(role)" [disabled]="role === 'ROLE_SUPER_ADMIN' && !currentUser?.roles?.includes('ROLE_SUPER_ADMIN')">
                {{ roles[role] }}
              </option>
            </select>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(userForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{ errorMessage }}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
